import TopMenu from "../components/shared/TopMenu";
import * as React from "react";
import Footer from "../components/shared/Footer";

export default function AuthorizedLayout(props) {
    return (<div id="authorizedLayout" className="layout">
        <TopMenu />
        {props.children}
        <Footer />
    </div>
    )
}